import { DEFAULT_PAGINATION } from 'core/constants/pagination.constants';
import { IUserParams } from 'core/model/interfaces/users';
import type { TSliceReducer } from 'core/store';
import type { IUsersState } from './types';

const updateUsersPage: TSliceReducer<IUsersState, number | undefined> = (state, { payload }) => {
  state.userList.pagination.currentPage = payload ?? 1;
};

const updateUserFilters: TSliceReducer<IUsersState, IUserParams> = (state, { payload }) => {
  state.filters = { ...state.filters, ...payload };
};

const clearUserFilters: TSliceReducer<IUsersState> = state => {
  state.filters = {};
};

const clearUserForm: TSliceReducer<IUsersState> = state => {
  state.form.errors = {};
  state.form.loading = false;
  state.form.success = false;
};

const clearUserList: TSliceReducer<IUsersState> = state => {
  state.userList.isLoading = false;
  state.userList.pagination = DEFAULT_PAGINATION;
  state.userList.data = [];
};

export const reducers = { updateUsersPage, updateUserFilters, clearUserFilters, clearUserForm, clearUserList };
